export const getZppCertifiedSubscriptionPlan = (state) => state.payment.subscriptionPlans.find(({ zppCertified }) => !!zppCertified);
